module.exports = __webpack_public_path__ + "static/media/facebook.82064c0a.webp";